module.exports = __webpack_public_path__ + "media/images/bg/patterns/ellipse-221b0ca33a2e4e3f360e1251bbbcfda6.svg";